export function parseOverlayEditor(editor) {
    return editor && isOverlayEditorInstance(editor) ? editor : undefined;
}
function isOverlayEditorInstance(editor) {
    return !!editor && 'editUI' in editor;
}
export function parseFullscreenEditor(editor) {
    return editor && isFullscreenEditorInstance(editor) ? editor : undefined;
}
function isFullscreenEditorInstance(editor) {
    return !!editor && 'fullscreenLayer' in editor;
}
//# sourceMappingURL=types.preenvesnextjs.map
